import { Switch } from "@material-ui/core";
import React, { Component, useState } from "react";
import { Image, Button, Row, Col } from "react-bootstrap";
import { RenderMultipleHoursInsideFields } from "../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddItem/Availability";

class EditModelBody extends Component {
  state = {
    ordertype: 0,
  };
  render() {
    const { ordertype } = this.state;
    return (
      <React.Fragment>
        <div className="superadmin-orderscomponent-main">
          Select one relevant option from below
          <br />
          <div>
            <Row style={{ marginLeft: "2%" }}>
              {orderTypes.map((data) => {
                return (
                  <Col
                    xs={3}
                    sm={3}
                    md={3}
                    className={`take-away-order-select 
                                  ${
                                    ordertype === data.id &&
                                    `take-away-order-select-selected`
                                  }`}
                    onClick={() => {
                      this.setState({ ordertype: data.id });
                    }}
                    style={{
                      padding: "2%",
                      marginRight: "1%",
                      marginBottom: "1%",
                    }}
                    key={data.id}
                  >
                    <span>{data.title}</span>
                  </Col>
                );
              })}
            </Row>
          </div>
          <div>
            {ordertype === 4 && (
              <div>
                <div className="f16-400">
                  Which Days and Times of the Week Item is available ?
                </div>
                <div className="onboarding_process_screen-left-mapinside px-0">
                  <div className="business_and_hours_onboarding_main">
                    <RenderMultipleHoursInsideFieldsMain />
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="d-flex align-items-center pt-5">
            <Button
              variant="outline-secondary"
              className="mr-4 px-5 py-2"
              //   onClick={(e) => this.props.history.push("/superadminorders")}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="px-5  py-2"
              //onClick={(e) => handleShowTab("2")}
              //type="submit"
              //   onClick={() => onClickStepOne()}
            >
              Update
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const foodTime = ["breakfast", "lunch", "dinner"];

const dayArray = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

const RenderMultipleHoursInsideFieldsMain = (props) => {
  const [state, setState] = useState({
    checkPoint: false,
    monday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    tuesday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    wednesday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    thursday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    friday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    saturday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    sunday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    auto_accept: false,
    errors: [],
  });

  /****************************
   * @DESC - DAY TOGGLER -
   ***************************/
  const onDayOpenCloseHanlder = (day, foodTime, multiple) => (e) => {
    let dayData = state[day];
    dayData.open = !dayData.open;
    setState({ ...state });
    if (dayData.open === false && multiple === "single") {
      dayData.breakfast.open = false;
      dayData.lunch.open = false;
      dayData.dinner.open = false;
    } else {
      setState({ ...state });
    }
    if (
      state["monday"].open === false &&
      state["tuesday"].open === false &&
      state["wednesday"].open === false &&
      state["thursday"].open === false &&
      state["friday"].open === false &&
      state["saturday"].open === false &&
      state["sunday"].open === false &&
      multiple === "multiple"
    ) {
      setState({
        ...state,
      });
    } else {
      setState({
        ...state,
      });
    }
  };

  /*****************************************
   * @DESC - Multiple Time Add Handlers
   ******************************************/
  const onMultipleAddHandler = (day) => (e) => {
    e.preventDefault();
    // let state = state;
    let dayData = state[day];
    let phone = dayData.multiple_timings;
    let dayDataDesc =
      phone[phone.length - 1] && phone[phone.length - 1].description;
    if (dayDataDesc === "") {
      const { errors } = state;
      errors.description = "Description Is Required";
      setState({
        ...state,
        errors: errors,
      });
    } else {
      let newMultiple = {
        open: true,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 23),
        description: "",
      };
      phone.push(newMultiple);
      setState({
        ...state,
        checkPoint: true,
      });
    }
  };

  const onMultileDeleteHandler = (day, index) => (e) => {
    e.preventDefault();
    // let state = state;
    let dayData = state[day];
    let phone = dayData.multiple_timings;
    if (phone.length === 1) {
      window.alert("Cannot Delete elements");
    } else {
      phone.splice(index, 1);
      setState({ ...state, errors: [] });
    }
    props.clear_all_errors();
  };

  const onFocusOut = (e) => {
    const { errors } = state;
    if (e.target.value === "") {
      errors[e.target.name] = `Description Is Required`;
    } else {
      errors[e.target.name] = "";
    }
    setState({
      ...state,
      errors: errors,
    });
  };

  return (
    <RenderMultipleHoursInsideFields
      state={state}
      onDayOpenCloseHanlder={onDayOpenCloseHanlder}
      addOnClick={onMultipleAddHandler}
      deleteOnClick={onMultileDeleteHandler}
      // handleChangeOpeningCloseing={handleChangeOpeningCloseing}
      // handleChangeInputTextArray={handleChangeInputTextArray}
      // handleChangeMultipleHoursToggle={handleChangeMultipleHoursToggle}
      onFocusOut={onFocusOut}
      // copyMultipleTimeFunctionError={copyMultipleTimeFunctionError}
      // copyMultipleTimeFunction={copyMultipleTimeFunction}
    />
  );
};

const addDays = [
  { day: "MONDAY" },
  { day: "TUESDAY" },
  { day: "WEDNESDAY" },
  { day: "THURSDAY" },
  { day: "FRIDAY" },
  { day: "SATURDAY" },
  { day: "SUNDAY" },
];

const orderTypes = [
  { id: 0, title: "All Day" },
  { id: 1, title: "Breakfast" },
  { id: 2, title: "Lunch" },
  { id: 3, title: "Dinner" },
  { id: 4, title: "Other" },
];

export default EditModelBody;
